module.exports = __webpack_public_path__ + "static/media/notSched.3bcba41c.svg";